import { useDeviceType } from "./useDeviceType";

export const useScrollToElement = (ref) => {
  const device = useDeviceType();

  const scrollToElement = () => {
    if (!ref.current) return;

    const element = ref.current;
    const top = device === "desktop" ? 66 : 100;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - top;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  return scrollToElement;
};
